/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";
import { Popover, Title, Button, Modal } from "rizzui";
import { DotIcon } from "@/components/icons/dot.tsx";
import { EActionMethod, IItemPayment } from "@/utilities/types/Payment.ts";
import { useCallback, useState } from "react";
import SelectReason from "./select-reason";
import { useModal } from "@/app/shared/modal-views/use-modal";
import CheckPayment from "./check-payment";
import ApprovePayment from "./approve-payment";

interface ChangeStatusProps {
  changeStatusPayment: (id: string, type: string, reason?: string) => Promise<void>;
  item: IItemPayment;
}

const OldAction = ({ changeStatusPayment, item }: ChangeStatusProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const [typeSubmit, setTypeSubmit] = useState<string>("");
  const PaymentStatusModal = () => {
    return (
      <Modal isOpen={isModalOpen} onClose={() => closeModal()} size="sm">
        <div className="p-6">
          <h2 className="text-2xl font-bold mb-6">Confirm Status Change</h2>
          <p>
            Are you sure you want to change the current status? This action
            cannot be undone.
          </p>
          <div className="mt-6 flex gap-3 justify-end">
            <Button onClick={() => closeModal()}>No</Button>
            <Button
              onClick={async () => {
                closeModal();
                await changeStatusPayment(item.xeroInvoiceID, typeSubmit);
              }}
              variant="outline"
              color="danger"
            >
              Yes
            </Button>
          </div>
        </div>
      </Modal>
    );
  };
  return (
    <>
      <Popover placement="left">
        <Popover.Trigger>
          <Button size="sm" variant="outline">
            <DotIcon />
          </Button>
        </Popover.Trigger>
        <Popover.Content>
          <Title as="h6" className="!mb-0 font-semibold">
            Change Status
          </Title>
          <div className="flex flex-col items gap-2 mt-2">
            <Button
              size="sm"
              onClick={() => {
                openModal();
                setTypeSubmit(EActionMethod.APPROVED);
              }}
            >
              {EActionMethod.APPROVED}
            </Button>
            <Button
              variant="outline"
              color="danger"
              size="sm"
              onClick={() => {
                openModal();
                setTypeSubmit(EActionMethod.REJECTED);
              }}
            >
              {EActionMethod.REJECTED}
            </Button>
          </div>
        </Popover.Content>
      </Popover>
      <PaymentStatusModal />
    </>
  );
};

export const ChangeStatus = (props: ChangeStatusProps) => {
  const { isOpen, openModal, closeModal } = useModal();

  const openModalApproved = useCallback(() => {
    openModal({
      view: <ApprovePayment closeModal={closeModal} {...props} />,
      customSize: "400px",
    });
  }, []);

  const openModalReject = useCallback(() => {
    openModal({
      view: (
        <SelectReason
          closeModal={closeModal}
          {...props}
        />
      ),
      customSize: "400px",
    });
  }, []);

  const openModalCheckPayment = useCallback(() => {
    openModal({
      view: (
        <CheckPayment
          onClose={closeModal}
          openModalReject={openModalReject}
          openModalApproved={openModalApproved}
          {...props}
        />
      ),
      customSize: "400px",
    });
  }, []);

  return (
    <>
      <Button size="sm" variant="outline" onClick={openModalCheckPayment}>
        <DotIcon />
      </Button>
    </>
  );
};
